import React from 'react';
import PropTypes from 'prop-types';
import {
  CallStatusTag,
  CallStatus,
} from '@rsos/components/capstone/Queue/EmergencyCall/EmergencyCall.styles';
import { getCallStatusName } from '@rsos/components/capstone/Queue/EmergencyCall/helpers';
import { Box, Text } from '@rsos/components/capstone/base';
import { getTheme } from '@rsos/theme/themes';
import { formatPhoneWithDashes } from '@rsos/utils';
import { convertUnixTimestamp } from '@rsos/utils/timeHelpers';
import { EMERGENCY_CALLS } from '../../../../../constants/incidentTypes';

/**
 * Wrapper component for Google Maps info window content.
 * This is an uncontrolled component, no access to the redux store or themes,
 * props should be passed down.
 * @param {string} type - content type for EMERGENCY CALLS or ALERTS
 * @param {object} data - content data based on content type
 * @param {boolean} isInternational - prop used for CALLS to format domestic telephone numbers
 * @param {object} callQueue - callQueue or filteredCalls
 * @returns Google Maps info window content
 */
const InfoWindowContent = ({
  type,
  data,
  isInternational,
  callStatus,
  themeName = 'light',
}) => {
  if (type === EMERGENCY_CALLS) {
    const theme = getTheme(themeName);
    const { caller_id, call_start_time } = data;
    const formattedCallerID = isInternational
      ? caller_id
      : formatPhoneWithDashes(caller_id);

    const callStatusDisplayName = getCallStatusName(callStatus);

    return (
      <Box>
        <Text marginBottom={'5px'}>{formattedCallerID}</Text>
        <Text marginBottom={'5px'}>
          {convertUnixTimestamp(Number(call_start_time), true)}
        </Text>

        {callStatusDisplayName && (
          <CallStatusTag status={callStatus} isCallPopup={true} theme={theme}>
            <CallStatus status={callStatus} theme={theme}>
              {callStatusDisplayName}
            </CallStatus>
          </CallStatusTag>
        )}
      </Box>
    );
  } else return null;
};

InfoWindowContent.propTypes = {
  type: PropTypes.string.isRequired,
  data: PropTypes.shape({}).isRequired,
  isInternational: PropTypes.bool,
  isAllView: PropTypes.bool,
};

export default InfoWindowContent;
